import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/dailyOtherCost/selectPage',
    method: 'GET',
    params: {
      ...params
    }
  })
}

// 导出成本统计
export function download (params) {
  return axios({
    url: '/dailyOtherCost/download',
    method: 'get',
    params: params,
    responseType: 'arraybuffer'
  })
}

// 财务确认总金额
export function isAmount (data) {
  return axios({
    url: '/dailyOtherCost/isAmount/' + data.id + '/' + data.isAmount,
    method: 'GET'
  })
}
